/**
 * TanStack Query hooks for `igaming-hybrid`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingHybridQueryKeys,
	type CreateIgamingHybridBody,
	type ListIgamingHybridResponse,
	type IgamingHybridRow,
} from "./api";

export function useIgamingHybridList(): UseQueryResult<ListIgamingHybridResponse, Error> {
	return useQuery({
		queryKey: igamingHybridQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingHybridCreate(): UseMutationResult<IgamingHybridRow, Error, CreateIgamingHybridBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingHybridQueryKeys.all });
		},
	});
}

export function useIgamingHybridDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingHybridQueryKeys.all });
		},
	});
}
